import { render } from "./Login.vue?vue&type=template&id=3b95fba0&scoped=true"
import script from "./Login.vue?vue&type=script&lang=js"
export * from "./Login.vue?vue&type=script&lang=js"

import "./Login.vue?vue&type=style&index=0&id=3b95fba0&lang=scss&scoped=true"

import exportComponent from "D:\\Front-end\\vuechat\\app-ua-truth-chat\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b95fba0"]])

export default __exports__